(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["fitree-our-story"] && !Shopify.designMode) return;
  try {
    
  (()=>{const init=root=>{if(!root||root.dataset.ready)return;root.dataset.ready='true';const reduce=matchMedia('(prefers-reduced-motion: reduce)').matches;const chapters=[...root.querySelectorAll('.fos__chapter[id]')],links=[...root.querySelectorAll('.fos__nav a')],progress=root.querySelector('.fos__progress');const update=()=>{const rect=root.getBoundingClientRect(),travel=Math.max(1,root.offsetHeight-innerHeight);progress.style.transform=`scaleX(${Math.max(0,Math.min(1,-rect.top/travel))})`;let active=chapters[0]?.id;chapters.forEach(ch=>{if(ch.getBoundingClientRect().top<innerHeight*.42)active=ch.id});links.forEach(a=>a.classList.toggle('is-active',a.hash===`#${active}`));if(!reduce)root.querySelectorAll('.fos__parallax').forEach(media=>{const r=media.getBoundingClientRect(),y=Math.max(-18,Math.min(18,(innerHeight/2-r.top-r.height/2)*.035));media.querySelector('img')?.style.setProperty('--parallax-y',`${y}px`)})};let ticking=false;addEventListener('scroll',()=>{if(!ticking){requestAnimationFrame(()=>{update();ticking=false});ticking=true}},{passive:true});update();const reveal=new IntersectionObserver(es=>es.forEach(e=>{if(e.isIntersecting){e.target.classList.add('is-visible');reveal.unobserve(e.target)}}),{threshold:.12});root.querySelectorAll('.fos__reveal').forEach(el=>reveal.observe(el));root.querySelectorAll('.fos__feature').forEach(btn=>btn.addEventListener('click',()=>{const open=btn.classList.toggle('is-open');btn.setAttribute('aria-expanded',String(open))}))};document.querySelectorAll('.fos').forEach(init);document.addEventListener('shopify:section:load',e=>init(e.target.querySelector('.fos')));})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
